exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#stackedBar{margin-top:20px}.axis-x_stackedBar>path,.axis-y_stackedBar>path{stroke:#4e4d4d}.stacked_bar_line{stroke:#565656;stroke-width:1.5px;fill:none;stroke-dasharray:2}.s_axis .tick line{stroke:none !important}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/StackedBarChart/style.scss
// module id = 1564
// module chunks = 0